export default __webpack_public_path__ + "static/media/naval_combat.85ccac21.png";